// extracted by mini-css-extract-plugin
module.exports = {"moviePosterImage":"index-module__moviePosterImage___26-nB"};